import React from 'react';
import './styles.scss';
import { Button, Card, Row, Col } from 'react-bootstrap';
import { S3_URL } from 'constants';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import { useCancelAdvertisementMutation } from 'services';
import useCommonStore, { setModalConfig } from 'store/common';
import useTranslate from 'hooks/useTranslate';

const AdvertisementBlock: React.FC<any> = ({ data, activeKey, refetch }) => {
	const { translate } = useTranslate();
	const { mutateAsync: cancelAdvertisement, isPending } = useCancelAdvertisementMutation();
	const { hideCommonModal }: any = useCommonStore((state) => state);

	const onCancelHandler = () => {
		cancelAdvertisement(Number(data?.id))
			.then((res: any) => {
				if (res?.success) {
					refetch();
				}
				hideCommonModal();
			})
			.catch(() => {});
	};

	const onHandleDelete = () => {
		setModalConfig({
			visible: true,
			type: 'confirmModal',
			onClick: () => onCancelHandler(),
			data: {
				title: translate('Modal.doYouWantToCancel'),
			},
			props: {
				dialogClassName: 'confirm-modal',
			},
		});
	};

	return (
		<Card key={data?.id} className="advertisement-card mb-3">
			<div className="advertisement-card-img">
				<Card.Img src={S3_URL + data?.image} />
			</div>
			<Card.Body className="p-0">
				<Card.Title className="p-3 mb-0 fw-bold">{data?.title}</Card.Title>
				<div className="card-content">
					<Row>
						<Col xs={4}>
							<p className="mb-0">{translate('Extras.days')}:</p>
						</Col>
						<Col>
							<h6 className="mb-0">{data?.days}</h6>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<p className="mb-0">{translate('Extras.startDate')}:</p>
						</Col>
						<Col>
							<h6 className="mb-0">{data?.startDate}</h6>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<p className="mb-0">{translate('Extras.endDate')}:</p>
						</Col>
						<Col>
							<h6 className="mb-0">{data?.endDate}</h6>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<p className="mb-0">{translate('Extras.status')}:</p>
						</Col>
						<Col>
							<h6
								className={`mb-0 text-capitalize ${data?.status === 'pending' ? 'text-danger' : ''}`}
							>
								{data?.status}
							</h6>
						</Col>
					</Row>
					<Row>
						<Col xs={4}>
							<p className="mb-0">{translate('Extras.amountPaid')}:</p>
						</Col>
						<Col>
							<h6 className="mb-0">{data?.price}</h6>
						</Col>
					</Row>
					{data?.description && (
						<Row>
							<Col xs={4}>
								<p className="mb-0">{translate('Extras.description')}:</p>
							</Col>
							<Col>
								<h6
									className="description-text mb-0"
									title={parse(sanitizeHtml(data?.description))}
								>
									{parse(sanitizeHtml(data?.description))}
								</h6>
							</Col>
						</Row>
					)}
				</div>
				<div className="p-3">
					{activeKey === 'active' ? (
						<Button
							disabled={isPending}
							className="filled-btn rounded-pill w-100"
							onClick={() => onHandleDelete()}
						>
							{translate('Extras.cancel')}
						</Button>
					) : (
						<></>
					)}
				</div>
			</Card.Body>
		</Card>
	);
};

export default AdvertisementBlock;
